
export class FileShareCreateEntity {
  providerInstanceId: string;
  name: string;
  userId: string|null;
  server: string;
  share: string;
  paths: string[];
}
